import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
declare var $: any;


@Injectable({
    providedIn: 'root'
})
export class GrievanceViewService {

    constructor() { 
        
    }

    modeldata: string;
    modal = new Subject();

    open() {
        $('#myModal1').modal('show')
        this.modal.next(true);
    }
    close() {
        $('#myModal1').modal('hide')
        this.modal.next(false);
        localStorage.removeItem('timeLine');

    }
    closeModal() {
        this.close();
    }
}
